import {HttpParams} from '@angular/common/http';

export enum ObjectQueryFilterOperator {
  Contains = '*',
  Equals = '=',
  In = '@'
}

export enum ObjectQuerySortDirection {
  Ascending = 'asc',
  Descending = 'desc'
}

class ObjectQueryPager {
  page: number;
  size: number;
}

class ObjectQueryFilter {
  name: string;
  operator: ObjectQueryFilterOperator;
  value: string;
}

class ObjectQuerySort {
  name: string;
  direction: ObjectQuerySortDirection;
}

export class ObjectQueryParameters {

  private pager: ObjectQueryPager;
  private filters: ObjectQueryFilter[];
  private sorts: ObjectQuerySort[];

  constructor() {
    this.pager = {page: 1, size: 20};
    this.filters = [];
    this.sorts = [];
  }

  addFilter(name: string, operator: ObjectQueryFilterOperator, value: string) {
    this.filters.push({
      name: name,
      operator: operator,
      value: value
    });
  }

  clearFilters() {
    this.filters = [];
  }

  addSort(name: string, direction: ObjectQuerySortDirection) {
    this.sorts.push({
      name: name,
      direction: direction
    });
  }

  clearSorts() {
    this.sorts = [];
  }

  setPage(page: number) {
    this.pager.page = page;
  }

  setPager(page: number, size: number) {
    this.pager.page = page;
    this.pager.size = size;
  }

  toHttpParams(): HttpParams {
    let params = new HttpParams();

    params = params.set('page', this.pager.page + ':' + this.pager.size);

    this.sorts.forEach(sort => {
      params = params.set('sort', sort.name + ':' + sort.direction);
    });

    this.filters.forEach(filter => {
      params = params.append('filter', filter.name + filter.operator + filter.value);
    });

    return params;
  }
}
